import {
  useEffect,
  useState,
  memo,
  lazy,
  Suspense,
  Dispatch,
  SetStateAction,
  useRef,
} from "react";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";
import styles from "./ChatSidebar.module.scss";
import { UserName } from "pages/ChatPage/pages/chatHistory/components/userName";
import useRouter from "hooks/useRouter";
import { RoutePaths } from "pages/routePaths";

import {
  EmptyThreadChat,
  EmptyUploadedFiles,
  IChat,
  setIsModalOpen,
  deleteAllChats,
  deleteAllConversation,
  setPagination,
  startNewChat,
  setShowWorkspaceList,
  setWsSearchQuery,
  setSearchActive,
  removeMultipleChat,
  deleteSingleChatHistory,
  DeleteS3Link,
} from "redux/actions";
import { useSelector } from "redux/hooks";
import links from "core/links";
import { ChatRoute } from "pages/ChatPage";
import { ChatSideBarFooter } from "./components/ChatSideBarFooter";
import { CreateFolder } from "./components/CreateFolder/CreateFolder";
import { ChatHistoryList } from "./components/ChatHistoryList/ChatHistoryList";
import { WorkspaceSearchField } from "pages/Workspaces/pages/WorkspaceConversation.tsx/InfoComponent/WorkspaceSearchField";
import AnimatedModal from "components/AnimateModal/AnimateModal";
import { UploadedFilePreview } from "pages/Workspaces/pages/WorkspaceConversation.tsx/Threads/Components/UploadedFilePreview";
import { EmptyObj } from "utils/fileProcessing";
import { Home } from "./components/icons/Home";
import { UseWsIcon } from "pages/Workspaces/components/icons/UseWsIcon";
import { DropDownOptions, NewTab } from "./components/icons/NewTab";
import { Dropdown, CustomFlowbiteTheme } from "flowbite-react";
import SidebarSubOption from "./components/SidebarSubOption/SidebarSubOption";
import {
  WorkspaceArrowIcon,
  WsRotateArrowIcon,
} from "./components/icons/WorkspaceIcon";
import { WorkspacesList } from "./components/ShowWorkspace/WorkspacesList";
import { useAppNotification } from "hooks/services/AppNotification";
import { DeleteChatConfirm } from "./components/DeleteChatConfirm";
import { useThreadsHistoryContext } from "hooks/ThreadHistoryContext";
import { useWindowSize } from "hooks/useWindowSize";
const FreeCreditsModal = lazy(() =>
  import("pages/ChatPage/components/freeCreditsModal").then((module) => ({
    default: module.FreeCreditsModal,
  }))
);
interface IProps {
  onSelectChatItem?: (chatItem: IChat | undefined, folder_id: number) => void;
  onStartNewChat?: ({
    toChat,
    PrivateChat,
    newChatbtn,
  }: {
    toChat: boolean;
    PrivateChat?: boolean;
    newChatbtn?: boolean;
  }) => void;
  isMainScreenOpen?: boolean;
  toggleSidebar?: any;
  itemStyles?: any;
  searchQuery?: string;
  setSearchQuery?: Dispatch<SetStateAction<string>>;
  // setOpenHistory?: Dispatch<SetStateAction<boolean>>;
  isAnswerComplete?: boolean;
  fileS3Link?: string[];
}

export const ChatSidebar = memo(
  ({
    onSelectChatItem,
    onStartNewChat,
    toggleSidebar,
    itemStyles,
    searchQuery,
    // setOpenHistory,
    isAnswerComplete,

    fileS3Link,
  }: IProps) => {
    const { onChangeChat } = useThreadsHistoryContext();
    const { pathname, includeRoute, push } = useRouter();
    const chatId = pathname.split("/")[3];
    const { showCreateWorkspace, isModalOpen, showWorkspaceList } = useSelector(
      (state) => state.workSpaceReducer
    );

    const workspaceListRef = useRef<HTMLDivElement>(null);
    const [workspaceListHeight, setWorkspaceListHeight] = useState<number>(0);

    const { Folders } = useSelector((state) => state.chatFolderReducer);
    const chatHistory = useSelector((state) => state.chatReducer.chats);
    const { userDetail, theme } = useSelector((state) => state.authReducer);
    const { newMessages } = useSelector((state) => state.chatReducer);
    const { PrivateChat } = useSelector((state) => state.chatReducer);
    const [showReferralModal, setShowReferralModal] = useState<boolean>(false);
    const [selectedItem, setSelectedItem] = useState<IChat | undefined>(
      undefined
    );
    const [createFolder, setCreateFolder] = useState<boolean>(false);
    const { width } = useWindowSize();
    // const workSpaceChat = pathname.includes("/workspaces");

    const [showConfirmModel, setShowConfirmModel] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const { triggerNotification } = useAppNotification();
    const isHomeActive = pathname.includes(`/${RoutePaths.Home}`);
    const isWsActive = pathname === `/${RoutePaths.Workspaces}`;

    const customTheme: CustomFlowbiteTheme["dropdown"] = {
      content: "modelModalScrollBar rounded-[10px]",
      floating: {
        base: `z-10 !min-w-[230px] ml-[-8px] top-[-67px] rounded-[8px] shadow-[0px_2px_12px_0px_rgba(0,0,0,0.35)] outline-none border-none dark:shadow-none focus:outline-none dark:bg-[#252526]
         ${width <= 505 ? "ml-[-23px]" : ""} `,
        style: {
          dark: "bg-[#252526] text-dark-light dark:bg-[#252526]",
          light: "bg-white text-light-default",
          auto: "bg-white text-light-default dark:bg-[#252526] dark:text-dark-default",
        },
      },
      arrowIcon: "hidden",
      inlineWrapper: "bg-transparent p-0 shadow-none",
    };

    useEffect(() => {
      if (workspaceListRef.current) {
        const height = showWorkspaceList
          ? workspaceListRef.current.scrollHeight
          : 0;
        setWorkspaceListHeight(height);
      }
    }, [showWorkspaceList]);

    useEffect(() => {
      if (chatId) {
        const index = chatHistory.findIndex(
          (item) => item.id === JSON.parse(chatId)
        );
        if (index >= 0) {
          setSelectedItem(chatHistory[index]);
        }
      } else {
        setSelectedItem(undefined);
      }
    }, [chatId, chatHistory]);

    const isButtonActive = (): boolean => {
      let isActive = false;
      if (includeRoute(ChatRoute.History) || newMessages.length > 0) {
        isActive = true;
      } else if (includeRoute(ChatRoute.New)) {
        isActive = true;
      } else if (includeRoute(RoutePaths.Workspaces)) {
        isActive = true;
      }
      return isActive;
    };

    const handleSubmit = () => {
      setLoading(true);
      setShowConfirmModel(false);
      deleteAllChats();
      setPagination(0, 0);
      setLoading(false);
      deleteAllConversation(true)
        .then(() => {
          setShowConfirmModel(false);
          setLoading(false);
        })
        .catch((err) => {
          setShowConfirmModel(false);
          setLoading(false);
          triggerNotification({ message: err?.data?.message, type: "error" });
        });
    };

    const handleDeleteS3Link = () => {
      fileS3Link?.map((file) => {
        DeleteS3Link(file);
      });
    };

    const Plan = userDetail && userDetail?.user?.activeSubscription?.name;

    return (
      <>
        {(PrivateChat || showCreateWorkspace) && (
          <div className={styles.backdrop}></div>
        )}
        <div className={classNames("font-inter", styles.container)}>
          <div className="flex gap-2 p-[12px]">
            <div className={`${styles.themeallow} `}>
              <button
                className={classNames(styles.newChatBtn, {
                  [styles.light]: theme === "light",
                  [styles.dark]: theme === "dark",
                  [styles.isActive]: isButtonActive(),
                  [styles.isbackdrop]: showCreateWorkspace,
                })}
                onClick={() => {
                  // if (workSpaceChat
                  // ) {
                  if (isAnswerComplete || isAnswerComplete === undefined) {
                    // If it's a private chat, execute the delete API
                    if (PrivateChat) {
                      const currentPath = window.location.pathname;
                      const pathSegments = currentPath.split("/");
                      const chatIdFromUrl =
                        pathSegments[pathSegments.length - 2];

                      if (Number(chatIdFromUrl)) {
                        deleteSingleChatHistory(Number(chatIdFromUrl));
                        removeMultipleChat([Number(chatIdFromUrl)]);
                        sessionStorage.removeItem("PrivateChatId");
                      }
                      handleDeleteS3Link();
                      push(`/${RoutePaths.Chat}/${ChatRoute.New}`);
                      startNewChat();
                      onChangeChat?.();
                    }
                    setIsModalOpen(true);
                    EmptyUploadedFiles();
                  }
                  // }
                  // else if (isButtonActive()) {
                  //   onStartNewChat?.({ toChat: true, newChatbtn: true });
                  // }
                }}
                data-testid="new-chat-btn"
              >
                <div
                  className={classNames(styles.btnContent, {
                    [styles.light]: theme === "light",
                    [styles.dark]: theme === "dark",
                    [styles.isActive]: isButtonActive(),
                    [styles.isbackdrop]: showCreateWorkspace,
                  })}
                >
                  <div className="flex justify-between w-full">
                    <div className={styles.text}>
                      <FormattedMessage id="sidebar.chat.newChat.btn.text" />
                    </div>
                    <div className="flex items-center gap-[3px]">
                      <span
                        className={classNames(styles.newChatBox, {
                          [styles.light]: theme === "light",
                          [styles.dark]: theme === "dark",
                        })}
                      >
                        {" "}
                        ⌘{" "}
                      </span>
                      <span
                        className={classNames(styles.newChatBox, {
                          [styles.light]: theme === "light",
                          [styles.dark]: theme === "dark",
                        })}
                      >
                        {" "}
                        K{" "}
                      </span>
                    </div>
                  </div>
                </div>
              </button>
            </div>
          </div>

          <div
            className={classNames(
              "flex gap-[12px] cursor-pointer p-[12px] hover:bg-[#E5E7EB] dark:hover:bg-[#343541] rounded-[4px]",
              {
                [styles.isbackdrop]: PrivateChat || showCreateWorkspace,
                "bg-[#E5E7EB] dark:bg-[#343541]": isHomeActive,
              }
            )}
            onClick={() => {
              onStartNewChat?.({ toChat: true, newChatbtn: true });
              setWsSearchQuery && setWsSearchQuery("");
              setSearchActive(false);
            
              push(`/${RoutePaths.Home}`);
            }}
            data-testid="sidebar-chat-newchat-workspace"
          >
           <Home isHomeActive={isHomeActive} theme={theme} />
            <div
              className={classNames("font-inter", styles.historyHeading, {
                [styles.light]: theme === "light",
                [styles.dark]: theme === "dark",
                [styles.activeLight]: theme === "light" && isHomeActive,
                [styles.activeDark]: theme === "dark" && isHomeActive,
              })}
            >
              <FormattedMessage id="sidebar.chat.newChat.home" />
            </div>
          </div>
          {userDetail?.user.team.role === "admin" && (
            <>
              <div
                className={classNames(
                  "flex gap-[12px] cursor-pointer p-[12px] hover:bg-[#E5E7EB] dark:hover:bg-[#343541] rounded-[4px] ",
                  {
                    [styles.isbackdrop]: PrivateChat || showCreateWorkspace,
                    "bg-[#E5E7EB] dark:bg-[#343541]": isWsActive,
                  }
                )}
                onClick={() => push(`/${RoutePaths.Workspaces}`)}
                data-testid="sidebar-chat-newchat-workspace"
              >
                <UseWsIcon
                  sidebar={true}
                  isWsActive={isWsActive}
                  theme={theme}
                />
                <div className="flex justify-between w-full items-center">
                  <div
                    className={classNames("font-inter", styles.historyHeading, {
                      [styles.light]: theme === "light",
                      [styles.dark]: theme === "dark",
                      [styles.activeLight]: theme === "light" && isWsActive,
                      [styles.activeDark]: theme === "dark" && isWsActive,
                    })}
                  >
                    <FormattedMessage id="sidebar.chat.newChat.workspace" />
                  </div>
                  <span
                    className={`flex-shrink-0 leading-[0] ${styles.arrowWrapper}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowWorkspaceList(!showWorkspaceList);
                    }}
                  >
                    <div className={styles.iconContainer}>
                      <div
                        className={classNames(
                          styles.icon,
                          styles.collapsedIcon,
                          {
                            [styles.hidden]: showWorkspaceList,
                          }
                        )}
                      >
                        <WorkspaceArrowIcon />
                      </div>

                      <div
                        className={classNames(
                          styles.icon,
                          styles.expandedIcon,
                          styles.delayed, // Add delayed animation timing
                          { [styles.visible]: showWorkspaceList }
                        )}
                      >
                        <WsRotateArrowIcon />
                      </div>
                    </div>
                  </span>
                </div>
              </div>

              {/* {showWorkspaceList &&  */}
              <div
                ref={workspaceListRef}
                className={classNames(styles.workspaceList, "mt-2", {
                  [styles.expanded]: showWorkspaceList,
                  [styles.collapsed]: !showWorkspaceList,
                })}
              >
                <WorkspacesList />
              </div>
            </>
          )}

          {createFolder && <CreateFolder setCreateFolder={setCreateFolder} />}
          <div
            className={classNames("overflow-hidden h-full", {
              "overflow-y-hidden": Folders.length === 0 && searchQuery === "",
              [styles.isbackdrop]: showCreateWorkspace,
              [styles.isScrollbackdrop]: PrivateChat,
            })}
          >
            <ChatHistoryList
              searchQuery={searchQuery || ""}
              onSelectChatItem={onSelectChatItem}
              setSelectedItem={setSelectedItem}
              // setOpenHistory={setOpenHistory}
              selectedItem={selectedItem}
              onStartNewChat={onStartNewChat}
              workspaceListHeight={showWorkspaceList ? workspaceListHeight : 0}
            />
          </div>

          <Dropdown
            theme={customTheme}
            label={
              <div style={{ backgroundColor: "none" }}>
                <div className="flex items-center justify-between my-1 px-[6px] mx-2 py-[6px] hover:bg-[#E5E7EB] dark:hover:bg-[#343541] group rounded">
                  <div className="flex items-center gap-[10px]">
                    <UserName
                      sidebar={true}
                      theme={theme}
                      name={userDetail?.user?.name}
                      email={userDetail?.user?.email}
                      className={styles.userAvatar}
                    />
                    <div className="flex flex-col items-start gap-1">
                      <span
                        className={classNames(
                          "font-inter text-left group-hover:text-[#4338CA] dark:group-hover:text-white",
                          styles.detail_Head,
                          {
                            [styles.light]: theme === "light",
                            [styles.dark]: theme === "dark",
                          }
                        )}
                      >
                        {userDetail?.user?.team?.name}
                      </span>
                      {userDetail?.user?.activeSubscription?.name && (
                        <div
                          className={classNames(
                            "font-inter font-medium group-hover:text-[#6366F1] dark:group-hover:text-white",
                            styles.detail_SubHead,
                            {
                              [styles.light]: theme === "light",
                              [styles.dark]: theme === "dark",
                            }
                          )}
                        >
                          {Plan === "Standard"
                            ? "Solo"
                            : Plan === "Professional"
                              ? "Pro"
                              : Plan === "Business"
                                ? "Enterprise"
                                : Plan}{" "}
                        </div>
                      )}
                    </div>
                  </div>
                  <span className="text-[#94A3B8] group-hover:text-[#4338CA] dark:group-hover:text-white flex flex-row items-center justify-center">
                    <DropDownOptions />
                  </span>
                </div>
              </div>
            }
            dismissOnClick={false}
            inline={true}
            placement="right"
            arrowIcon={false}
          >
            <SidebarSubOption
              setShowReferralModal={setShowReferralModal}
              setShowConfirmModel={setShowConfirmModel}
            />
          </Dropdown>
          <div
            className={classNames(styles.seprator, {
              [styles.light]: theme === "light",
              [styles.dark]: theme === "dark",
            })}
          ></div>
          <div
            className={classNames(styles.footer, {
              [styles.light]: theme === "light",
              [styles.dark]: theme === "dark",
            })}
          >
            <div className={styles.Hidefootersetting}>
              <ChatSideBarFooter
                itemStyles={itemStyles}
                toggleSidebar={toggleSidebar}
                userDetail={userDetail}
                theme={theme}
              />
            </div>
            <div className={styles.themeallow}>
              <a
                href={links.ChromeStorePluginUrl}
                target="_blank"
                rel="noreferrer"
                className={classNames(styles.itemContainer, {
                  [styles.light]: theme === "light",
                  [styles.dark]: theme === "dark",
                  [styles.isbackdrop]: PrivateChat || showCreateWorkspace,
                })}
                data-testid="chrome-store-plugin"
              >
                <span className="flex justify-between w-full p-[12px] items-center">
                  <span className="flex items-center gap-[8px]">
                    <img
                      src="/ChromeIcon.svg"
                      height={"22px"}
                      width={"22px"}
                      style={{ backgroundColor: "transparent" }}
                    />
                    <span
                      className={classNames(styles.itemText, {
                        [styles.light]: theme === "light",
                        [styles.dark]: theme === "dark",
                      })}
                    >
                      <FormattedMessage id="sidebar.chat.newChat.addToChrome" />
                    </span>
                  </span>

                  <NewTab />
                </span>
              </a>
            </div>
          </div>
        </div>
        {isModalOpen && (
          <AnimatedModal
            isOpen={isModalOpen}
            onClose={() => {
              setIsModalOpen(false);
              EmptyUploadedFiles();
              EmptyThreadChat(EmptyObj);
            }}
            threads={true}
          >
            <UploadedFilePreview />
            <WorkspaceSearchField threads={true} chat={true} wsNewChat={true} />
          </AnimatedModal>
        )}
        {showConfirmModel && (
          <DeleteChatConfirm
            onCancel={() => setShowConfirmModel(false)}
            onSubmit={handleSubmit}
            loading={loading}
            delConversation={true}
          />
        )}
        <Suspense fallback={<></>}>
          {showReferralModal && (
            <FreeCreditsModal onClose={() => setShowReferralModal(false)} />
          )}
        </Suspense>
      </>
    );
  }
);
